
import clsx from 'clsx';
import type { FC } from 'react';
import type { PreloaderProps } from './preloader.types';

/**
 * Preloader component used for loading process indication.
 *
 * @author Adam Halasz
 * @category Components
 * @see PreloaderProps
 */
const Preloader: FC<PreloaderProps> = ({ size, className }) => (
<div
  className={clsx(
    'flex-none animate-spin rounded-full border-t-4 border-primary-400',
    {
      'w-4 h-4': size === 'S',
      'w-5 h-5': size === 'M',
      'w-12 h-12': size === 'L',
    },
    className
  )}
/>
);

export { Preloader };
